import React, { useEffect, useState, useRef } from "react";

const PaymentDetailsModel = ({ isOpen, onClose, paymentData, onSubmit }) => {
  const [totalDays, setTotalDays] = useState(paymentData.totalDays);
  const [amountPerDay, setAmountPerDay] = useState(paymentData.amountPerDay);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // Manage loading state
  const [isClosing, setIsClosing] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTotalDays(paymentData.totalDays);
      setAmountPerDay(paymentData.amountPerDay);
      setTotalAmount(paymentData.totalDays * paymentData.amountPerDay);
    }
  }, [isOpen, paymentData]);

  useEffect(() => {
    const calculatedTotal = totalDays * amountPerDay;
    setTotalAmount(calculatedTotal);
  }, [totalDays, amountPerDay]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleSubmit = async () => {
    setIsLoading(true); // Start loader
    try {
      const paymentToSubmit = {
        ownerId: paymentData.ownerId,
        month: paymentData.month,
        totalDays: totalDays,
        amountPerDay: amountPerDay,
        status: paymentData.status,
        totalAmount: totalAmount,
        screenId: paymentData.screenId,
      };

      console.log("Screen Id", paymentData.screenId);
      await onSubmit(paymentToSubmit); // Call onSubmit with payment data
      handleCloseModal(); // Close modal after submission
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false); // Stop loader after process completes
    }
  };

  const handleCloseModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300);
  };

  if (!isOpen && !isClosing) return null;

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 transition-opacity duration-300 ${
        isOpen && !isClosing ? "opacity-100" : "opacity-0"
      }`}
    >
      <div
        ref={modalRef}
        className={`bg-white w-full max-w-lg p-5 rounded-lg relative transform transition-transform duration-300 ${
          isOpen && !isClosing ? "scale-100" : "scale-95"
        }`}
      >
        <button
          className="absolute top-3 right-3 text-gray-600"
          onClick={handleCloseModal}
        >
          ✕
        </button>

        <h2 className="text-xl font-semibold text-center mb-4">
          Payment Details
        </h2>

        <div className="mb-5">
          <h3 className="text-gray-500 text-sm font-semibold mb-4">
            Owner Information
          </h3>

          <div className="mb-4">
            <label className="block text-gray-700">Owner Name</label>
            <input
              type="text"
              value={paymentData.ownerName}
              readOnly
              className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Month</label>
            <input
              type="text"
              value={paymentData.month}
              readOnly
              className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Total Days</label>
            <input
              type="number"
              value={totalDays}
              readOnly
              className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Amount Per Day</label>
            <input
              type="number"
              name="amountPerDay"
              value={amountPerDay}
              onChange={(e) => setAmountPerDay(Number(e.target.value))}
              className="w-full p-2 border border-gray-300 rounded mt-1"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Total Amount</label>
            <input
              type="text"
              value={totalAmount}
              readOnly
              className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100"
            />
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={handleSubmit}
            type="submit"
            disabled={isLoading} // Disable button when loading
            className={`bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-600 ${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isLoading ? "Processing..." : "Submit Payment"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsModel;
